module.exports = __webpack_public_path__ + "img/menu_ADD.0d501808.svg";